export default {
    popupList: [],
    popupListCount: 0,
}